module.exports = __webpack_public_path__ + "img/canceled.30809cae.gif";